/**
 * @generated SignedSource<<cad6b46a9fe50e7e3193f283a0ad1bc8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type uiMetaField_Query$variables = Record<PropertyKey, never>;
export type uiMetaField_Query$data = {
  readonly siteSettings: {
    readonly hdLogo: {
      readonly __typename: "SiteSettingsUiMetaField";
      readonly classes: ReadonlyArray<string | null | undefined> | null | undefined;
      readonly conditions: ReadonlyArray<string | null | undefined> | null | undefined;
      readonly id: string | null | undefined;
      readonly mediaItem: {
        readonly description: string | null | undefined;
        readonly id: string;
        readonly mediaDetails: {
          readonly sizes: ReadonlyArray<{
            readonly name: string | null | undefined;
            readonly sourceUrl: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly mediaItemUrl: string | null | undefined;
        readonly mimeType: string | null | undefined;
      } | null | undefined;
      readonly style: string | null | undefined;
      readonly value: string | null | undefined;
    } | null | undefined;
    readonly hdLogoText: {
      readonly __typename: "SiteSettingsUiMetaField";
      readonly classes: ReadonlyArray<string | null | undefined> | null | undefined;
      readonly conditions: ReadonlyArray<string | null | undefined> | null | undefined;
      readonly id: string | null | undefined;
      readonly mediaItem: {
        readonly description: string | null | undefined;
        readonly id: string;
        readonly mediaDetails: {
          readonly sizes: ReadonlyArray<{
            readonly name: string | null | undefined;
            readonly sourceUrl: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly mediaItemUrl: string | null | undefined;
        readonly mimeType: string | null | undefined;
      } | null | undefined;
      readonly style: string | null | undefined;
      readonly value: string | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type uiMetaField_Query = {
  response: uiMetaField_Query$data;
  variables: uiMetaField_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  },
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "classes",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "conditions",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "style",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "MediaItem",
    "kind": "LinkedField",
    "name": "mediaItem",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mediaItemUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mimeType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MediaDetails",
        "kind": "LinkedField",
        "name": "mediaDetails",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MediaSize",
            "kind": "LinkedField",
            "name": "sizes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sourceUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SiteSettings",
    "kind": "LinkedField",
    "name": "siteSettings",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "SiteSettingsUiMetaField",
        "kind": "LinkedField",
        "name": "hdLogoText",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SiteSettingsUiMetaField",
        "kind": "LinkedField",
        "name": "hdLogo",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "uiMetaField_Query",
    "selections": (v2/*: any*/),
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "uiMetaField_Query",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "0ded28f73536284d99b4fdd1ba8f7da6",
    "id": null,
    "metadata": {},
    "name": "uiMetaField_Query",
    "operationKind": "query",
    "text": "query uiMetaField_Query {\n  siteSettings {\n    id\n    hdLogoText {\n      __typename\n      id\n      value\n      classes\n      conditions\n      style\n      mediaItem {\n        id\n        mediaItemUrl\n        mimeType\n        mediaDetails {\n          sizes {\n            sourceUrl\n            name\n          }\n        }\n        description\n      }\n    }\n    hdLogo {\n      __typename\n      id\n      value\n      classes\n      conditions\n      style\n      mediaItem {\n        id\n        mediaItemUrl\n        mimeType\n        mediaDetails {\n          sizes {\n            sourceUrl\n            name\n          }\n        }\n        description\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1655e9dd3ece43a09fe0b5a20a90a924";

export default node;
